/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_IncludedInputs */

const en_vault_included = /** @type {(inputs: Vault_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Included`)
};

const es_vault_included = /** @type {(inputs: Vault_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bóveda incluida`)
};

const fr_vault_included = /** @type {(inputs: Vault_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coffre-fort inclus`)
};

const de_vault_included = /** @type {(inputs: Vault_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault inklusive`)
};

const ja_vault_included = /** @type {(inputs: Vault_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保管庫へのアクセス付き`)
};

const zh_vault_included = /** @type {(inputs: Vault_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含金库内容`)
};

const ar_vault_included = /** @type {(inputs: Vault_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخزنة متضمنة`)
};

const id_vault_included = /** @type {(inputs: Vault_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termasuk Vault`)
};

const it_vault_included = /** @type {(inputs: Vault_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Incluso`)
};

const ru_vault_included = /** @type {(inputs: Vault_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранилище включено`)
};

const pt_vault_included = /** @type {(inputs: Vault_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cofre Incluído`)
};

const ko_vault_included = /** @type {(inputs: Vault_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault(보관소) 포함`)
};

/**
* | output |
* | --- |
* | "Vault Included" |
*
* @param {Vault_IncludedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_included = /** @type {((inputs?: Vault_IncludedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_IncludedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_included(inputs)
	if (locale === "es") return es_vault_included(inputs)
	if (locale === "fr") return fr_vault_included(inputs)
	if (locale === "de") return de_vault_included(inputs)
	if (locale === "ja") return ja_vault_included(inputs)
	if (locale === "zh") return zh_vault_included(inputs)
	if (locale === "ar") return ar_vault_included(inputs)
	if (locale === "id") return id_vault_included(inputs)
	if (locale === "it") return it_vault_included(inputs)
	if (locale === "ru") return ru_vault_included(inputs)
	if (locale === "pt") return pt_vault_included(inputs)
	return ko_vault_included(inputs)
});